import { render } from "./S158465.vue?vue&type=template&id=24003d9e"
const script = {}
script.render = render

export default script